import {VariantConfigT} from '@/lib/types/colors.types';

export const instagramConfig: VariantConfigT = {
  basic: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  outline: {
    icon: 'instagram',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'instagram',
    iconHover: 'instagram',
    iconActive: 'instagram',
    hover: 'instagram',
    active: 'instagram',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
